import React, { useContext, useRef, useState, useEffect } from 'react';
import { TemplateContext } from '../layout';
import CrossIcon from '/fallbacks/cross.svg';
import { CSSTransition } from 'react-transition-group';

const WarrantyPopup = ({ data }) => {
	const buttonTheme = data.checkout_v3_popupBtnTheme;
	const popupTheme = data.checkout_v3_popupTheme;
	const [showPopup, setShowPopup] = useState(false);
	const [templateContext, setTemplateContext] = useContext(TemplateContext);
	const nodeRef = useRef(null);

	const popupRef = useRef(null);

	const checkWarranty = () => {
		setTemplateContext((prevContext) => ({
			...prevContext,
			config: { ...prevContext.config, warrantyState: true },
			popupClicked: true,
			displayPopup: false,
		}));
	};

	const closePopup = () => {
		setTemplateContext((prevContext) => ({
			...prevContext,
			popupClicked: true,
			displayPopup: false,
		}));
	};

	useEffect(() => {
		if (
			templateContext?.popupClicked == false &&
			templateContext?.config?.warrantyState == false &&
			templateContext?.displayPopup
		) {
			setShowPopup(true);
			setTimeout(() => {
				popupRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
			}, 300);
		} else {
			setShowPopup(false);
		}
	}, [templateContext?.popupClicked, templateContext?.config?.warrantyState, templateContext?.displayPopup]);

	useEffect(() => {
		setTimeout(() => {
			closePopup();
		}, [window.productData.submit_without_warranty * 1000 || 10000]);
	}, []);

	const animationStyle = showPopup
		? {
				opacity: 1,
				visibility: 'visible',
		  }
		: {
				opacity: 0,
				visibility: 'hidden',
		  };

	return (
		<CSSTransition ref={nodeRef} in={showPopup} timeout={300} classNames="warrantyPopup-transition">
			<div
				ref={popupRef}
				className={popupTheme == 'light' ? 'warantyPopupOuter' : 'warantyPopupOuter warantyPopupOuter--dark'}
				style={animationStyle}
			>
				<div className="warantyPopupInner" style={animationStyle}>
					<div className="warantyPopupInner__head">
						<div className="warantyPopupInner__heading">{data?.tr_checkout_v3_popupHeading}</div>
						<span
							className="warantyPopupInner__cross"
							style={{
								backgroundImage: `url(${CrossIcon})`,
							}}
							onClick={() => {
								closePopup();
							}}
						></span>
					</div>
					<div className="warantyPopupInner__content">
						<p className="warantyPopupInner__text">{data?.tr_checkout_v3_popupDescription}</p>
						<button
							className="button button--warranty"
							theme={buttonTheme}
							onClick={() => {
								checkWarranty();
							}}
						>
							{data?.tr_checkout_v3_popupCTA}
						</button>
					</div>
				</div>
				<div className="warantyPopupOuter__arrow"></div>
			</div>
		</CSSTransition>
	);
};

export default WarrantyPopup;
